import { FC } from 'react';
import { useIntl } from 'react-intl';

import { formatTime } from '@/shared/lib/helpers/formatTime';

import {
  getRecordingsDurationSec,
  hasInterruptedRecording,
  TranscriptorConsultation,
} from '@/entities/transcriptor';

import { dentalConsultationMessages } from '../../config';
import { ConsultationNotice } from '../ConsultationNotice';

type InterruptedRecordingNoticeProps = {
  consultation?: TranscriptorConsultation | null;
  className?: string;
};

/**
 * A summary generated from a recording that stopped on its own (dead mic,
 * closed tab, lost network) looks exactly like a complete one. This notice
 * is the only thing telling the doctor how much of the consultation it
 * actually covers, so it renders regardless of processing status.
 */
export const InterruptedRecordingNotice: FC<
  InterruptedRecordingNoticeProps
> = ({ consultation, className }) => {
  const { formatMessage } = useIntl();

  if (!hasInterruptedRecording(consultation)) {
    return null;
  }

  return (
    <ConsultationNotice
      className={className}
      title={formatMessage(
        dentalConsultationMessages.recordingInterruptedLabel,
      )}
      message={formatMessage(
        dentalConsultationMessages.recordingInterruptedMessage,
        { duration: formatTime(getRecordingsDurationSec(consultation)) },
      )}
    />
  );
};
